var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Watch, Prop, Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { TemplateService } from "~/services/manage-service/template.service";
var MessageTemplete = /** @class */ (function (_super) {
    __extends(MessageTemplete, _super);
    function MessageTemplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.messageModel = {
            principalId: "",
            principalName: "",
            isDefault: false,
            templateName: "",
            isEnabled: "YES",
            content: "",
            type: "SMS"
        };
        _this.defaultFlag = false;
        _this.isModify = false;
        _this.rules = {
            principalId: [
                {
                    required: true,
                    message: "请选择委托方",
                    trigger: "blur"
                }
            ],
            content: [
                {
                    required: true,
                    message: "请输入短信内容",
                    trigger: "blur"
                },
                {
                    min: 0,
                    max: 1000,
                    message: "不超过1000个字符",
                    trigger: "blur"
                }
            ],
            templateName: [
                {
                    required: true,
                    message: "请输入模板名称",
                    trigger: "blur"
                },
                {
                    min: 2,
                    max: 10,
                    message: "长度在 2 到 10 个字符",
                    trigger: "blur"
                }
            ]
        };
        return _this;
    }
    MessageTemplete.prototype.close = function () {
        var messageFrom = this.$refs["message-form"];
        messageFrom.resetFields();
        this.messageModel.isDefault = false;
    };
    MessageTemplete.prototype.success = function () { };
    MessageTemplete.prototype.updateDataChange = function (val) {
        if (!val)
            return;
        this.isModify = true;
        this.messageModel = Object.assign({}, this.updateData);
        this.messageModel.isDefault =
            this.messageModel.isDefault === "YES" ? true : false;
    };
    /**
     * 提交新建模板按钮
     */
    MessageTemplete.prototype.submitClick = function (type) {
        var _this = this;
        var messageFrom = this.$refs["message-form"];
        messageFrom.validate(function (valid) {
            if (!valid) {
                return;
            }
            if (_this.messageModel.isDefault && _this.messageModel.isEnabled === "NO") {
                _this.$message({
                    type: "info",
                    message: "默认模板不可设为停用!"
                });
                return;
            }
            switch (type) {
                case "add":
                    _this.addTemplate();
                    break;
                case "update":
                    _this.modifyTemplate();
                    break;
            }
        });
    };
    /**
     * 新建模板
     */
    MessageTemplete.prototype.addTemplate = function () {
        var _this = this;
        var messageModel = Object.assign({}, this.messageModel);
        messageModel.isDefault = this.messageModel.isDefault ? "YES" : "NO";
        messageModel.principalName =
            this.principalList.find(function (v) { return v.id === messageModel.principalId; })
                .name || "";
        this.loading.state = true;
        this.templateService.createTemplate(messageModel, this.loading).subscribe(function (data) {
            _this.$message({
                type: "success",
                message: "新增模版成功!"
            });
            _this.$emit("success");
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    /**
     * 修改模板
     */
    MessageTemplete.prototype.modifyTemplate = function () {
        var _this = this;
        var messageModel = Object.assign({}, this.messageModel);
        messageModel.isDefault = this.messageModel.isDefault ? "YES" : "NO";
        messageModel.principalName =
            this.principalList.find(function (v) { return v.id === messageModel.principalId; })
                .name || "";
        this.loading.state = true;
        this.templateService.updateTemplate(messageModel, this.loading).subscribe(function (data) {
            _this.$message({
                type: "success",
                message: "修改模版成功!"
            });
            _this.$emit("success");
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(TemplateService)
    ], MessageTemplete.prototype, "templateService", void 0);
    __decorate([
        State
    ], MessageTemplete.prototype, "principalList", void 0);
    __decorate([
        Emit("close")
    ], MessageTemplete.prototype, "close", null);
    __decorate([
        Emit("success")
    ], MessageTemplete.prototype, "success", null);
    __decorate([
        Prop()
    ], MessageTemplete.prototype, "updateData", void 0);
    __decorate([
        Watch("updateData", { immediate: true })
    ], MessageTemplete.prototype, "updateDataChange", null);
    MessageTemplete = __decorate([
        Component({
            components: {}
        })
    ], MessageTemplete);
    return MessageTemplete;
}(Vue));
export default MessageTemplete;
